class AgencyList {
    id = null;
    name = '';
    agenciesids = null;
    createdby = "";
    updatedby = "";
}
export default AgencyList;